import React from 'react';
import { ResponsiveContainer } from 'recharts';

const CustomResponsiveContainer = props => <ResponsiveContainer {...props} />;

export default CustomResponsiveContainer;
